import { RepoError } from '@webapp/infrastructure/interfaces/repositories/RepoError'
import { type ExpenseReportFormSchema } from '@webapp/modules/expense/components/CreateExpenseReportForm'
import { ExpenseStatuses } from '@webapp/modules/expense/entities/enums/ExpenseStatusEnum'
import { type IExpenseRepository } from '../../interfaces/IExpenseRepository'

export class SaveExpenseDraftUseCase {
  constructor(private readonly expenseRepository: IExpenseRepository) {}

  execute = async (
    formValues: ExpenseReportFormSchema
  ): Promise<{ id: number }> => {
    try {
      const result = await this.expenseRepository.createExpenseRequest(
        formValues,
        ExpenseStatuses.DRAFT,
        false
      )
      return { id: result.id }
    } catch (err) {
      if (
        !(err instanceof RepoError) ||
        !(Array.isArray(err.response) && err.response[0]?.draft)
      ) {
        throw err
      }

      await this.expenseRepository.deleteExpenseRequest()
      const retryResult = await this.expenseRepository.createExpenseRequest(
        formValues,
        ExpenseStatuses.DRAFT,
        false
      )
      return { id: retryResult.id }
    }
  }
}
